// Projects.js
import React from "react";
import "./Projects.css";
import ProjectSummary from "./ProjectSummary";
import { getEnabledProjects } from "../data/projectData";

export default function Projects() {
  const enabledProjects = getEnabledProjects();

  return (
    <section className="projects" id="projects">
      <div className="projects-eyebrow">PROJECTS</div>
      <div className="projects-desc">
        Featured work that showcases my expertise in design and development.
      </div>

      {Object.entries(enabledProjects).map(([projectId, project]) => (
        <ProjectSummary
          key={projectId}
          video={project.isVideo ? project.image : undefined}
          image={!project.isVideo ? project.image : undefined}
          eyebrow={project.category}
          title={`${project.title} – ${project.subtitle}`}
          link={`/project/${projectId}`}
        />
      ))}
    </section>
  );
}
